import Decimal from 'decimal.js';
import Numeric   from '@/core/types/Numeric';
import Dimension from '@/core/types/Dimension';
import Volume    from '@/core/types/Volume';
import Title_ru_RU_Class from '@/core/misc/decorators/Title_ru_RU_Class';

/**
 * Площадь. Точность — 0 знаков.
 *
 * Единица — КВАДРАТНЫЕ МИЛЛИМЕТРЫ: тип промежуточный в цепочке
 * Dimension × Dimension × Dimension → Volume, своей колонки в базе нет,
 * пользователю сам по себе не показывается. Пока мы в мм — всё целое и
 * точное, конверсия единиц происходит ровно один раз, на последнем шаге
 * (см. mul). Если площадь понадобится как самостоятельная витринная
 * величина (м²) — это будет отдельное решение, не менять единицу здесь.
 */
@Title_ru_RU_Class('Площадь')
class Area extends Numeric {
    static readonly SCALE = 0;

    /** Результат вычисления — уже посчитанный Decimal. */
    static fromOperation(value: Decimal): Area {
        return new Area(value);
    }

    /**
     * Площадь × размер = объём.
     * Здесь единственная конверсия единиц: мм² × мм = мм³, делим на 1e9 → м³.
     * Деление на 1e9 в decimal — сдвиг запятой, потерь нет; округление вверх
     * до 3 знаков сделает конструктор Volume.
     */
    mul(dimension: Dimension | null | undefined): Volume {
        return Volume.fromOperation(
            this.value.times(Area.toDecimal(dimension)).dividedBy(1_000_000_000),
        );
    }
}

export default Area;